import * as React from 'react';
import './ShippingLabelToPrint.scss';

interface IContentToShippingLabelPrintProps {
  shippingLabel: any[];
}

class ShippingLabelToPrint extends React.Component<IContentToShippingLabelPrintProps, any> {
  public render() {
    return (
      <div className="rp-content-to-print">
        

      {this.props.shippingLabel && this.props.shippingLabel.map(img => (
                <div className="rp-content-to-print-row">
                  <div className="container-fluid">
                        <p className="rp-content-to-print-row-content quantity text-center">
                        <img 
                        src={`${img.labelPath}`}
                      />
                        </p>
                  </div>
                </div>
              ))}

       
      </div>
    );
  }
}

export default ShippingLabelToPrint;
